import PropTypes from "prop-types";
import {
  WarningBanner,
  WarningHeader,
  WarningLabel,
  WarningBody,
  LinkBtn,
} from "../FeeNoticeQueueStyled";
import { duplicateFlagMessage } from "../utils";

/**
 * One duplication question only (Matthew, 2026-07-24 follow-up): "has
 * this award already been ENTERED?" — the backend compares the letter
 * against existing Salesforce Resolutions and already-confirmed queue
 * entries (never against unentered sibling letters). Sorted
 * strongest-first (`fee_notice_math.compute_duplicate_flags`); a
 * decision-date match, or date AND amount together, is `strong`.
 */
const DuplicateFlagsBanner = ({ flags, onDismissAsDuplicate, disabled }) => {
  if (!flags || flags.length === 0) return null;

  return (
    <>
      {flags.map((flag, index) => (
        <WarningBanner
          key={`${flag.kind}-${flag.sf_id || flag.item_id}-${index}`}
          tone={flag.strength}
        >
          <WarningHeader>
            <WarningLabel tone={flag.strength}>
              {flag.strength === "strong"
                ? "Already entered"
                : "Possibly already entered"}
            </WarningLabel>
            <LinkBtn
              type="button"
              disabled={disabled}
              onClick={() => onDismissAsDuplicate(flag)}
            >
              Dismiss as duplicate
            </LinkBtn>
          </WarningHeader>
          <WarningBody>{duplicateFlagMessage(flag)}</WarningBody>
        </WarningBanner>
      ))}
    </>
  );
};

DuplicateFlagsBanner.propTypes = {
  flags: PropTypes.array,
  onDismissAsDuplicate: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DuplicateFlagsBanner;
